import { render, staticRenderFns } from "./Transport.vue?vue&type=template&id=2c4b171f&scoped=true"
import script from "./Transport.vue?vue&type=script&lang=js"
export * from "./Transport.vue?vue&type=script&lang=js"
import style0 from "./Transport.vue?vue&type=style&index=0&id=2c4b171f&prod&lang=css"
import style1 from "./Transport.vue?vue&type=style&index=1&id=2c4b171f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4b171f",
  null
  
)

export default component.exports